import { RouteRecordRaw } from 'vue-router'
import { userRoute } from './user'

export const route: Array<RouteRecordRaw> = [
    {
        path: '/',
        name: 'Index',
        component: () => import('@/views/index/index.vue'),
        meta: { title: '首页', share: true },
    },
    {
        path: '/hospital/:clinicId',
        name: 'clinicDetail',
        component: () => import('@/views/index/detail.vue'),
        meta: { title: '诊所详情', share: true },
    },
    // 门诊预约
    {
        path: '/hospital/list',
        name: 'clinicList',
        component: () => import('@/views/index/list.vue'),
        meta: { title: '门诊预约', share: true },
    },
    // 预约取消通知 跳转/team?hospital=&brandId=
    {
        path: '/team',
        name: 'TemplateMsgTeam',
        component: () => import('@/views/doctor/index.vue'),
        meta: { title: '医生团队', share: true },
    },
    {
        path: '/teams/:clinicId',
        name: 'DoctorList',
        component: () => import('@/views/doctor/index.vue'),
        meta: { title: '医生团队', share: true },
    },

    {
        path: '/doc/:clinicId/:doctorId',
        name: 'DoctorDetail',
        component: () => import('@/views/doctor/detail.vue'),
        meta: { title: '医生详情', share: true },
    },
    {
        path: '/evaluationDoc',
        name: 'EvaluationDoc',
        component: () => import('@/views/doctor/evaluationDoc.vue'),
        meta: { title: '评价医生' },
    },
    {
        path: '/evaluationDocList',
        name: 'EvaluationDocList',
        component: () => import('@/views/doctor/evaluationList.vue'),
        meta: { title: '评价列表' },
    },
    {
        path: '/evaluationHospitaList',
        name: 'EvaluationHospitaList',
        component: () => import('@/views/index/component/evaluationList.vue'),
        meta: { title: '评价列表' },
    },

    // 预约
    {
        path: '/booking/:clinicId',
        name: 'Booking',
        component: () => import('@/views/booking/index.vue'),
        meta: { title: '在线预约', share: true },
    },
    {
        path: '/bind',
        component: () => import('@/views/bindUser/index.vue'),
        meta: { title: '关联就诊人' },
    },
    // 查看影像
    {
        path: '/dicom',
        component: () => import('@/views/medicalRecord/dicom.vue'),
        meta: { title: '查看影像' },
    },
    // 满意度调查 \ 随访
    {
        path: '/satisfaction',
        component: () => import('@/views/satisfaction/index.vue'),
        meta: { title: '满意度调查' },
    },
    {
        path: '/satisfaction/state',
        component: () => import('@/views/satisfaction/state.vue'),
        meta: { title: '提示' },
    },
    {
        path: '/comment/:cid',
        component: () => import('@/views/medicalRecord/detail.vue'),
        meta: { title: '病例点评' },
    },
    /**
     * 我的
     **/
    ...userRoute,
    /**
     * 其他页面补漏
     */
    // 第三方预约
    {
        path: '/noauth/reservation',
        component: () => import('@/views/noauth/reservation.vue'),
        meta: { title: '挂号预约单' },
    },
    // 病历扫码上传
    {
        path: '/noauth/caseUpload',
        component: () => import('@/views/noauth/caseUpload.vue'),
        meta: { title: '病历扫码上传' },
    },
    /**
     * 模板消息中转页
     */
    {
        path: '/templateMsg',
        name: 'ProjectTemplateMsg',
        component: () => import('@/views/wx/templateMsg.vue'),
    },
    // 扫码登录 - saas
    {
        path: '/qrcodeLogin',
        name: 'SaasQrCodeLogin',
        component: () => import('@/views/noauth/qrcodeLogin.vue'),
        meta: { title: '扫码登录' },
    },
    // 电子签名
    {
        path: '/noauth/elecSign',
        name: 'ElecSign',
        component: () => import('@/views/noauth/electronicSignature.vue'),
        meta: { title: '电子签名' },
    },
    // 自助机账号密码登录
    {
        path: '/noauth/selfLogin',
        name: 'SelfLogin',
        component: () => import('@/views/noauth/selfLogin.vue'),
        meta: { title: '若邻门诊自助系统登录' },
    },
    // 自助机账号密码登录 - 选择诊室
    {
        path: '/noauth/clincRoom',
        name: 'ClincRoom',
        component: () => import('@/views/noauth/clincRoom.vue'),
        meta: { title: '选择诊室' },
    },
    // 自助挂号 - 定位
    {
        path: '/noauth/self/regTransition',
        name: 'RegTransition',
        beforeEnter(to, from, next) {
            let bid = to.query.brandId || to.params.brandId
            next(`/?brandId=${bid}`)
        },
        component: () => import('@/views/booking/selfRegTransition.vue'),
        meta: { title: '自助挂号' },
    },
    // 自助挂号
    {
        path: '/noauth/regAdd/:hid',
        name: 'selfRegAdd',
        // beforeEnter(to, from, next) {
        //     let bid = to.query.brandId || to.params.brandId
        //     next(`/?brandId=${bid}`)
        // },
        component: () => import('@/views/noauth/regAdd.vue'),
        meta: { title: '自助挂号' },
    },
    // 挂号成功页面
    {
        path: '/noauth/regSuccess',
        name: 'RegistrationSucceed',
        component: () => import('@/views/noauth/regAddState.vue'),
        meta: { title: '自助挂号' },
    },
    // info 中转页
    {
        path: '/info',
        name: 'Info',
        component: () => import('@/views/wx/info.vue'),
    },
    // 授权
    {
        path: '/authorize',
        name: 'Authorize',
        component: () => import('@/views/authorize/index.vue'),
        meta: { title: '用户登录' },
    },
    // 预约详情
    {
        path: '/booking/details',
        name: 'BookingDetails',
        component: () => import('@/views/booked/details.vue'),
        meta: { title: '预约详情' },
    },
    {
        path: '/examinationTriage',
        name: 'ExaminationTriage',
        component: () => import('@/views/noauth/examinationTriage.vue'),
        meta: { title: '预检分诊表单填写' },
    },
]
